import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Whether third-party payer must be specified when creating moves.
 */
export const schema = z.boolean();

export type RequireThirdPartyPayer = z.infer<typeof schema>;

export const definition = define({
  key: 'require_third_party_payer',
  schema,
  label: 'Require Third Party Payer',
  description: 'Require the client to input a third party payer when creating moves through the portal or API.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.THIRD_PARTY_PAYER.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.ORGANIZATION, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: false,
});
